import { psychologicalRound } from './psychologicalRound'
import { formatMoneyAmount, currencySymbol } from './symbols'
import type { DisplayCurrency, DisplayPriceInfo, FxRates } from './types'
import { rateFor } from './rates'

export function convertUsdToDisplay(
  usd: number,
  currency: DisplayCurrency,
  fx: FxRates | null,
): number {
  if (!Number.isFinite(usd) || usd < 0) return 0
  if (currency === 'USD') return Math.round(usd * 100) / 100
  const rate = rateFor(currency, fx)
  const raw = usd * rate
  return psychologicalRound(raw)
}

export function buildDisplayPrice(
  usd: number,
  currency: DisplayCurrency,
  fx: FxRates | null,
): DisplayPriceInfo {
  const display = convertUsdToDisplay(usd, currency, fx)
  return {
    usd,
    display,
    currency,
    symbol: currencySymbol(currency),
    formatted: formatMoneyAmount(display, currency),
  }
}
